import { createAction } from 'redux-actions'

import {
  GET_EXPENSE_WORKFLOW_STATUSES,
  GET_EXPENSE_WORKFLOW_STATUSES_FAILED,
  GET_EXPENSE_WORKFLOW_STATUSES_SUCCEEDED,
} from 'Redux/Types/WorkFlowStatusesTypes'

export const getWorkFlowStatuses = createAction(GET_EXPENSE_WORKFLOW_STATUSES)
export const getWorkFlowStatusesFailed = createAction(GET_EXPENSE_WORKFLOW_STATUSES_FAILED)
export const getWorkFlowStatusesSucceeded = createAction(GET_EXPENSE_WORKFLOW_STATUSES_SUCCEEDED)
